import NutzerschlagwortModalBase from "../NutzerschlagwortObjektModalBase.js";

import {
  EventBus,
} from "../../../global/functions/event-bus";
import {
  cloneDeep,
  map,
  pick,
} from "lodash-es";

// @vue/component
export default {
  name: "NutzerschlagwortObjektModalRemove",
  mixins: [
    NutzerschlagwortModalBase
  ],
  props: {
    modalButtonSaveText: {
      type: String,
      default: "_BTN_REMOVE_"
    },
  },
  data() {
    return {
      defaultMsg: "_HTML_NUTZERSCHLAGWORTOBJEKT_MODAL_REMOVE_INFO_{{anz}}_",
      defaultTitle: "_TXT_NUTZERSCHLAGWORTOBJEKT_MODAL_REMOVE_TITLE_{{anz}}_",
    };
  },
  methods: {
    save() {
      this.status.loading = true;
      const DATA = {
        objekte: map(this.objekte, el => pick(el, ["content_type", "pk"])),
        schlagworte: cloneDeep(this.selection)
      };
      this.postHttp({
        url: "nutzerschlagwortobjekte/batch_remove/",
        data: DATA,
        showError: true,
      }).then(
        () => {
          this.addNotification({ text: "_MSG_NUTZERSCHLAGWORTOBJEKT_MODAL_REMOVE_SUCCESS_" });
          this.close({ status: true });
          EventBus.$emit("updateNurzerschlagworte");
        },
        error => {
          this.onError({ error });
        }
      ).finally(
        () => this.status.loading = false
      );
    },
  },
};
